const keys = [
    {
        key: 1,
        height: 50,
        width: 100,
        left: 0,
        bottom: 0,
        idx:0,
        color:'lightslategrey'
    },
    {
        key: 2,
        height: 50,
        width: 100,
        left: 100,
        bottom: 0,
        idx:1,
        color:'lightslategrey'
    },
    {
        key: 3,
        height: 50,
        width: 100,
        left: 200,
        bottom: 0,
        idx:2,
        color:'lightslategrey'
    },
    {
        key: 4,
        height: 50,
        width: 100,
        left: 0,
        bottom: 50,
        idx:3,
        color:'lightslategrey'
    },
    {
        key: 5,
        height: 50,
        width: 100,
        left: 100,
        bottom: 50,
        idx:4,
        color:'lightslategrey'
    },
    {
        key: 6,
        height: 50,
        width: 100,
        left: 200,
        bottom: 50,
        idx:5,
        color:'lightslategrey'
    },
    {
        key: 7,
        height: 50,
        width: 100,
        left: 0,
        bottom: 100,
        idx:6,
        color:'lightslategrey'
    },
    {
        key: 8,
        height: 50,
        width: 100,
        left: 100,
        bottom: 100,
        idx:7,
        color:'lightslategrey'
    },
    {
        key: 9,
        height: 50,
        width: 100,
        left: 200,
        bottom: 100,
        idx:8,
        color:'lightslategrey'
    },
    {
        key: '.',
        height: 50,
        width: 100,
        left: 0,
        bottom: 150,
        idx:9,
        color:'lightslategrey'
    },
    {
        key: '=',
        height: 50,
        width: 100,
        left: 100,
        bottom: 150,
        idx:10,
        color:'lime'
    },
    {
        key: 0,
        height: 50,
        width: 100,
        left: 200,
        bottom: 150,
        idx:11,
        color:'lightslategrey'
    },
    {
        key: '+',
        height: 50,
        width: 75,
        left: 0,
        bottom: 200,
        idx:12,
        color:'yellow'
    },
    {
        key: '-',
        height: 50,
        width: 75,
        left: 75,
        bottom: 200,
        idx:13,
        color:'yellow'
    },
    {
        key: '*',
        height: 50,
        width: 75,
        left: 150,
        bottom: 200,
        idx:14,
        color:'yellow'
    },
    {
        key: '/',
        height: 50,
        width: 75,
        left: 225,
        bottom: 200,
        idx:15,
        color:'yellow'
    },
    {
        key: '⚡',
        height: 50,
        width: 75,
        left: 0,
        bottom: 250,
        idx:16,
        color:'steelblue'
    },
    {
        key: 'AC',
        height: 50,
        width: 75,
        left: 75,
        bottom: 250,
        idx:17,
        color:'red'
    },
    {
        key: 'DISPLAY',
        height: 50,
        width: 150,
        left: 150,
        bottom: 250,
        idx:18,
        color:'lightgrey'
    },
]

export default keys